import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SubtleBadge from "components/common/SubtleBadge";
import { AuthProvider, useAuth } from "contexts/AuthContext";
import useFormattedDate from "hooks/useFormatDate";
import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";

export const ClientIDUpdateModal = ({
  selectedID,
  loading,
  showUpdateModal,
  setShowUpdateModal,
  updateClientID,
}) => {
  const { user } = useAuth();
  const { formatDateTime } = useFormattedDate();
  const [status, setStatus] = useState("");
  const [type, setType] = useState("");
  const [label, setLabel] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedID) return;

    // Copy object and only change status
    const updatedData = {
      status: status,
      updatedBy: user.id,
      updatedAt: new Date().toISOString(),
    };

    try {
      await updateClientID(selectedID.id, updatedData);
    } catch (err) {
      console.error("Error updating Client ID:", err);
    } finally {
      setShowUpdateModal(false);
      setStatus("");
    }
  };

  useEffect(() => {
    if (!selectedID?.status) return;

    const statusMap = {
      ACTIVE: { type: "success", label: "ACTIVE" },
      NEW: { type: "primary", label: "NEW" },
      BLOCKED: { type: "danger", label: "BLOCKED" },
      SUSPENDED: { type: "warning", label: "SUSPENDED" },
      INACTIVE: { type: "secondary", label: "INACTIVE" },
      RATE_LIMITED: { type: "info", label: "RATE LIMITED" },
      THROTTLED: { type: "dark", label: "THROTTLED" },
      DELETED: { type: "danger", label: "DELETED" },
    };

    const { type, label } = statusMap[selectedID?.status];
    setType(type);
    setLabel(label);
  }, [selectedID]);

  return (
    <Modal
      show={showUpdateModal}
      onHide={() => setShowUpdateModal(false)}
      centered
      className="modal-small-text"
    >
      <Modal.Header className="py-3 fw-bold" style={{ fontSize: 14 }}>
        Update Client ID
      </Modal.Header>
      <Modal.Body style={{ fontSize: "0.83rem" }}>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="success" />
          </div>
        ) : selectedID ? (
          <>
            <div>
              <p>
                <strong>Client ID:</strong> {selectedID.id}
              </p>
              <p>
                <strong>API Key:</strong> {selectedID.apiKeyId}
              </p>
              <div className="d-flex gap-2 mb-3">
                <strong>Status:</strong>{" "}
                <SubtleBadge
                  pill
                  bg={type}
                  className="flex align-items-center justify-content-center"
                >
                  {label}
                </SubtleBadge>
              </div>
              <p>
                <strong>Created At:</strong>{" "}
                {formatDateTime(selectedID.createdAt)}
              </p>
            </div>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mt-3">
                <Form.Label>Update status</Form.Label>
                <Form.Select
                  size="sm"
                  onChange={(e) => setStatus(e.target.value)}
                  style={{ fontSize: "13.33px" }}
                >
                  <option value="">Select option</option>
                  <option value="ACTIVE">ACTIVATE</option>
                  <option value="SUSPENDED">SUSPEND</option>
                  <option value="BLOCKED">BLOCK</option>
                  <option value="THROTTLED">THROTTLE</option>
                </Form.Select>
              </Form.Group>

              <div className="d-flex justify-content-end mt-4">
                <Button
                  size="sm"
                  variant="secondary"
                  onClick={() => setShowUpdateModal(false)}
                  className="me-2"
                >
                  Cancel
                </Button>
                <Button
                  size="sm"
                  type="submit"
                  variant="success"
                  disabled={!status}
                >
                  Save
                </Button>
              </div>
            </Form>
          </>
        ) : (
          <p>Client ID not found!</p>
        )}
      </Modal.Body>
    </Modal>
  );
};
